import HeroNew from '../components/HeroNew'
import ProductShowcase from '../components/ProductShowcase'
import TwoPaths from '../components/TwoPaths'
import Showcase from '../components/Showcase'
import StatsBar from '../components/StatsBar'
import Testimonials from '../components/Testimonials'
import Why from '../components/Why'
import FAQ from '../components/FAQ'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ROUTES } from '../config/constants'

export default function Home() {
  return (
    <div className="pt-16">
      {/* 1. Hero — Dual CTA + App Mockup */}
      <HeroNew />

      {/* 2. Product Showcase — Desktop Tool Features */}
      <ProductShowcase />

      {/* 3. Two Paths — Upload Service vs Desktop Tool */}
      <TwoPaths />

      {/* 4. Before/After Showcase + Reel Previews */}
      <Showcase />

      {/* 5. Stats / Social Proof */}
      <StatsBar />

      {/* 6. Testimonials */}
      <Testimonials />

      {/* 7. Why Choose Us */}
      <Why />

      {/* 8. FAQ — Objection Handling */}
      <FAQ />

      {/* 7. Final CTA */}
      <section className="py-24 px-4 relative overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-pitch-green/10 rounded-full blur-[200px]" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="container mx-auto text-center relative z-10"
        >
          <h2 className="text-4xl md:text-6xl font-black mb-6">
            <span className="text-white">Don't Let Your Best Shots </span>
            <span className="gradient-text">Disappear Forever.</span>
          </h2>
          <p className="text-lg text-gray-400 mb-10 max-w-lg mx-auto">
            Every match has a highlight reel inside it. Let us find yours — delivered in 24–72 hours.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={ROUTES.UPLOAD}
              id="cta-upload-bottom"
              className="inline-flex items-center gap-2 bg-pitch-green text-stadium-black px-10 py-4 rounded-full text-lg font-bold hover:bg-neon-green transition-all transform hover:scale-105 shadow-lg shadow-pitch-green/30"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              Get My Highlight Reel →
            </Link>
            <Link
              to={ROUTES.DOWNLOAD}
              id="cta-download-bottom"
              className="inline-flex items-center gap-2 px-10 py-4 rounded-full text-lg font-bold border-2 border-white/20 text-white hover:border-pitch-green/50 hover:text-pitch-green transition-all transform hover:scale-105"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Edit Reels Myself — Free
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
  )
}
